import {
  createStore
} from 'vuex'
import getters from './getters'

import permission from './permission'
import business from './business'
import unique from './unique'
import policy_no from './policy_no'

export default createStore({
  state: {},
  mutations: {},
  modules: {
    permission,
    business,
    unique,
    policy_no
  },
  getters
})